'use client'

import { useTherapistsApiRequest } from '@tebuto/functions/hooks'
import SWRConfiguration from '@tebuto/layout/SWRConfiguration'
import { createContext } from 'react'

export const CurrentLoginStatusContext = createContext<boolean>(false)

interface LoginStatusGuardProps {
    children: React.ReactNode
    initialIsLoggedIn?: boolean
}

export function LoginStatusGuard({ children, initialIsLoggedIn = false }: LoginStatusGuardProps) {
    return (
        <SWRConfiguration>
            <Provider initialIsLoggedIn={initialIsLoggedIn}>{children}</Provider>
        </SWRConfiguration>
    )
}

function Provider({ children, initialIsLoggedIn }: { children: React.ReactNode; initialIsLoggedIn: boolean }) {
    const { data: userContext, error } = useTherapistsApiRequest('who-am-i', (api) => api.whoAmI.whoAmI(), {
        handleUnauthorized: false,
        onError: () => undefined
    })

    const isLoggedIn = userContext ? true : error ? false : initialIsLoggedIn

    return <CurrentLoginStatusContext.Provider value={isLoggedIn}>{children}</CurrentLoginStatusContext.Provider>
}
